<div class="modal-content">
  <div class="modal-header">
    <div class="pb-4">
      <i aria-label="Close" (click)="handleClick()" class="close pull-right align-middle fas fa-times"> </i>
    </div>
    <h4 jhiTranslate="cutoff.home.help"></h4>
  </div>
  <div class="mt-3 alert alert-info">
    <p jhiTranslate="baryApp.how-to.upload-cutoff.intro"></p>
    <div class="h5">
      <span jhiTranslate="baryApp.how-to.upload-cutoff.file"></span>
    </div>
    <p jhiTranslate="baryApp.how-to.upload-cutoff.format"></p>
    <ul>
      <li jhiTranslate="baryApp.how-to.upload-cutoff.column1"></li>
      <li jhiTranslate="baryApp.how-to.upload-cutoff.column2"></li>
      <li jhiTranslate="baryApp.how-to.upload-cutoff.column3"></li>
      <li jhiTranslate="baryApp.how-to.upload-cutoff.column4"></li>
    </ul>
    <p jhiTranslate="baryApp.how-to.upload-cutoff.sheets"></p>
    <div class="h5">
      <jhi-bary-icon icon="info-circle" [faDirective]="FAS" class="info-text pr-2" aria-hidden="true"></jhi-bary-icon>
      <span jhiTranslate="baryApp.how-to.upload-cutoff.sample"></span>
    </div>
    <table class="table bg-white">
      <tr class="bg-main">
        <th jhiTranslate="baryApp.how-to.upload-cutoff.tab.countryDeparture"></th>
        <th jhiTranslate="baryApp.how-to.upload-cutoff.tab.zipCodeDeparture"></th>
        <th jhiTranslate="baryApp.how-to.upload-cutoff.tab.cutoffHour"></th>
        <th jhiTranslate="baryApp.how-to.upload-cutoff.tab.cutoffDay"></th>
      </tr>
      <tr>
        <td>FR</td>
        <td>33700</td>
        <th>18</th>
        <th>0</th>
      </tr>
      <tr>
        <td>FR</td>
        <td>75000</td>
        <th>14</th>
        <th>-1</th>
      </tr>
    </table>
    <br />
    <div class="h5">
      <jhi-bary-icon icon="info-circle" [faDirective]="FAS" class="info-text pr-2" aria-hidden="true"></jhi-bary-icon>
      <span jhiTranslate="baryApp.how-to.upload-cutoff.priority"></span>
    </div>
    <p jhiTranslate="baryApp.how-to.upload-cutoff.rules"></p>
    <p jhiTranslate="baryApp.how-to.upload-cutoff.algorithm"></p>
    <div class="h5">
      <span jhiTranslate="baryApp.how-to.upload-cutoff.flatZipCode"></span>
    </div>
    <p jhiTranslate="baryApp.how-to.upload-cutoff.p1"></p>
    <div class="h5">
      <span jhiTranslate="baryApp.how-to.upload-cutoff.wildCardRule"></span>
    </div>
    <p jhiTranslate="baryApp.how-to.upload-cutoff.p2"></p>
    <div class="h5">
      <span jhiTranslate="baryApp.how-to.upload-cutoff.startRule"></span>
    </div>
    <p jhiTranslate="baryApp.how-to.upload-cutoff.p3"></p>
    <div class="h5">
      <span jhiTranslate="baryApp.how-to.upload-cutoff.rangeRule"></span>
    </div>
    <p jhiTranslate="baryApp.how-to.upload-cutoff.p4"></p>
    <div class="h5">
      <span jhiTranslate="baryApp.how-to.upload-cutoff.pipeRule"></span>
    </div>
    <p jhiTranslate="baryApp.how-to.upload-cutoff.p5"></p>
    <div class="h5">
      <span jhiTranslate="baryApp.how-to.upload-cutoff.score"></span>
    </div>
    <p jhiTranslate="baryApp.how-to.upload-cutoff.scoreDetails"></p>
    <br />
    <div class="h5">
      <jhi-bary-icon icon="info-circle" [faDirective]="FAS" class="info-text pr-2" aria-hidden="true"></jhi-bary-icon>
      <span jhiTranslate="baryApp.how-to.upload-cutoff.sampleRules"></span>
    </div>
    <p jhiTranslate="baryApp.how-to.upload-cutoff.sampleRules1"></p>
    <br />
    <table class="table bg-white">
      <tr class="bg-main">
        <th jhiTranslate="baryApp.how-to.upload-cutoff.tab.countryDeparture"></th>
        <th jhiTranslate="baryApp.how-to.upload-cutoff.tab.zipCodeDeparture"></th>
        <th jhiTranslate="baryApp.how-to.upload-cutoff.tab.cutoffHour"></th>
      </tr>
      <tr>
        <td>FR</td>
        <td>#33</td>
        <td>18</td>
      </tr>
      <tr>
        <td>FR</td>
        <td>33700</td>
        <td>17</td>
      </tr>
      <tr>
        <td>FR</td>
        <td>40***</td>
        <td>16</td>
      </tr>
      <tr>
        <td>FR</td>
        <td>34***</td>
        <td>18</td>
      </tr>
    </table>
    <br />
    <p jhiTranslate="baryApp.how-to.upload-cutoff.sampleRules2"></p>
    <table class="table bg-white">
      <tr class="bg-main">
        <th jhiTranslate="baryApp.how-to.upload-cutoff.tab.countryDeparture"></th>
        <th jhiTranslate="baryApp.how-to.upload-cutoff.tab.zipCodeDeparture"></th>
        <th jhiTranslate="baryApp.how-to.upload-cutoff.tab.cutoffHour"></th>
        <th class="bg-info">Score</th>
      </tr>
      <tr>
        <td>FR</td>
        <td>#33</td>
        <td>18</td>
        <td class="bg-info">2</td>
      </tr>
      <tr>
        <td>FR</td>
        <td>33700</td>
        <td>17</td>
        <td class="bg-info">5</td>
      </tr>
    </table>
    <br />
    <p jhiTranslate="baryApp.how-to.upload-cutoff.sampleRules3"></p>
  </div>
</div>
